// Animation des formulaires
$(function () {
    if ($('.js-validation .form-group')) {
        $('.js-validation .form-control').each(function () {
            if ($(this).val().length > 0) {
                $(this).closest('.form-group').addClass('is-filled');
            }
        });

        $('.js-validation select').each(function () {
            if ($(this).val().length > 0) {
                $(this).closest('.form-group').addClass('is-filled');
            }
        });

        $('.js-validation textarea').each(function () {
            $(this).closest('.form-group').addClass('form-textarea');
        });

        $('.js-validation .input.checkbox').each(function () {
            $(this).closest('.form-group').addClass('form-checkbox');
        });

        $('.js-validation .form-control').keyup(function () {
            if ($(this).val().length > 0) {
                $(this).closest('.form-group').addClass('is-filled');
            } else {
                $(this).closest('.form-group').removeClass('is-filled');
            }
        });

        $('.js-validation select').change(function () {
            if ($(this).val().length > 0) {
                $(this).closest('.form-group').addClass('is-filled');
            } else {
                $(this).closest('.form-group').removeClass('is-filled');
            }
        });

        $('.form-control').on('focus', function () {
            $(this).closest('.form-group').toggleClass('has-focus');
        });
        $('.form-control').on('focusout', function () {
            $(this).closest('.form-group').removeClass('has-focus');
        });
    }
});
